import * as React from 'react';
import { Manager, Reference, Popper } from 'react-popper';
import { Portal } from './Portal';
import { useTransition } from 'react-spring';
export var Positioner = function Positioner(_a) {
  var target = _a.target,
      _b = _a.positionFixed,
      positionFixed = _b === void 0 ? 'absolute' : _b,
      _c = _a.isOpen,
      isOpen = _c === void 0 ? true : _c,
      children = _a.children,
      placement = _a.placement;
  var transitions = useTransition(isOpen, {
    from: {
      opacity: 1
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      mass: 1,
      tension: 185,
      friction: 26
    }
  });
  return React.createElement(Manager, null, React.createElement(Reference, null, target), transitions(function (_a, item) {
    var opacity = _a.opacity;
    return item && React.createElement(Portal, null, React.createElement(Popper, {
      placement: placement,
      strategy: positionFixed,
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 20]
        }
      }]
    }, function (props) {
      return children(props, opacity);
    }));
  }));
};